import { AutopickingRevenue } from "../api/models";
import { formatCurrency } from "../utils";

export interface Props {
    autopickingRevenue?: AutopickingRevenue[];
}

const RevenueRuleBreakdown = (props: Props) => {
    if (!props.autopickingRevenue) {
        return <div className="text-sm text-text-3 py-4 text-center">Not Available</div>;
    }

    const totalRevenue = props.autopickingRevenue.reduce((acc, cur) => acc + cur.parkingRevenueUsd, 0.0);
    const sorted = [...props.autopickingRevenue].sort((a, b) => b.parkingRevenueUsd - a.parkingRevenueUsd);

    return (
        <table className="w-full table-fixed">
            <colgroup>
                <col />
                <col className="w-[36px]" />
                <col className="w-[68px]" />
            </colgroup>
            <thead>
                <tr>
                    <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-1 px-1">Rule</th>
                    <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-1 px-1">%</th>
                    <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-1 px-1">Rev</th>
                </tr>
            </thead>
            <tbody>
                {sorted.slice(0, 10).map((r) => (
                    <tr key={r.name} className="border-t border-border">
                        <td className="py-1 px-1 text-xs text-text-2 truncate" title={r.name}>{r.name}</td>
                        <td className="py-1 px-1 text-right font-mono text-xs text-text-3 tabular-nums whitespace-nowrap">
                            {totalRevenue > 0 ? ((r.parkingRevenueUsd / totalRevenue) * 100).toFixed(0) + '%' : '—'}
                        </td>
                        <td className="py-1 px-1 text-right font-mono text-xs text-text tabular-nums whitespace-nowrap">{formatCurrency(r.parkingRevenueUsd)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default RevenueRuleBreakdown;
